import { render, staticRenderFns } from "./OpenBillingOrderItemComponent.vue?vue&type=template&id=41097cc1&scoped=true&"
import script from "./OpenBillingOrderItemComponent.vue?vue&type=script&lang=js&"
export * from "./OpenBillingOrderItemComponent.vue?vue&type=script&lang=js&"
import style0 from "./OpenBillingOrderItemComponent.vue?vue&type=style&index=0&id=41097cc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41097cc1",
  null
  
)

export default component.exports